import http from '@/http'
const URL = '/admin/partners'

export const list = async (params) => {
  const list = (await http.get(URL + `/${params.partner_id}/products`, { params: params }))
  return list
}

export const getCategories = async (params) => {
  const list = (await http.get(URL + `/${params.partner_id}/categories`, { params: params }))
  return list
}

export const find = async (params) => {
  let one = null
  if (params.id) {
    one = (await http.get(URL + `/${params.partner_id}/products/${params.id}`))
  }
  return one
}

export const findCategory = async (params) => {
  let one = null
  if (params.id) {
    one = (await http.get(URL + `/${params.partner_id}/categories/${params.id}`))
  }
  return one
}

export const save = (payload) => {
  let id = ''
  if (payload.get('id') > 0) {
    id = payload.get('id')
  }

  return http.post(URL + `/${payload.get('partner_id')}/products/${id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const saveCategory = (payload) => {
  let id = payload.id || ''
  return http.post(URL + `/${payload.partner_id}/categories/${id}`, payload)
}

export const deleteProduct = async (payload) => http.delete(URL + `/${payload.partner_id}/products/${payload.id}`)
export const deleteCategory = async (payload) => http.delete(URL + `/${payload.partner_id}/categories/${payload.id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload.partner_id}/products/${payload.id}/status`, payload)

export default {
  list,
  getCategories,
  saveCategory,
  find,
  findCategory,
  save,
  changeStatus,
  deleteProduct,
  deleteCategory
}
